import {IPFS_GATEWAY} from "../config";
import { ethers } from 'ethers';
import {
	NFT_ADDRESS,
	STAKING_TOKEN,
	PAYMENT_TOKEN,
	SP_TOKEN_FACTORY,
	MARKETPLACE_ADDRESS,
	PANCAKE_ROUTER,
	MAX_TIMESTAMP,
	NUSIC_VAULT,
	ALLOCATION_ADDRESS,
	ZERO_ADDRESS,
	SPTOKEN_VAULT,
	PANCAKE_FEE_RATE,
	SLIPPAGE_RATE
} from "../config";
import sptokenFactory from '../abi/sptoken_factory.json';
import erc20 from '../abi/erc20.json';
import nft from '../abi/nft.json';
import marketplace from '../abi/marketplace.json'
import sptokenAbi from '../abi/sptoken.json';
import pancakeRouter from '../abi/pancake.json';
import nusicVault from '../abi/nusicVault.json';
import allocationData from '../abi/allocation_data.json';
import sptoken_vault from '../abi/sptoken_vault.json';
import pancake_pair from '../abi/pancake_pair.json';

import intl from '../utils/intl';

const { ethereum } = window; //injected by metamask
const provider = new ethers.providers.Web3Provider(ethereum); 
const signer = provider.getSigner(); 

export const ZERO = ethers.constants.Zero;

export const participants = [{
	id: 0,
	name: intl.get("staker"),
}, {
	id: 1,
	name: intl.get("ip_owner")
}, {
	id: 2, 
	name: intl.get("ip_agent")
}, {
	id: 3,
	name: intl.get("ip_incentive")
}, {
	id: 4,
	name: intl.get("main_node")
}, {
	id: 5,
	name: intl.get("tiny_node")
}, {
	id: 6, 
	name: intl.get("tech")
}, {
	id: 7,
	name: intl.get("community")
}, {
	id: 8,
	name: intl.get("liquidity")
}, {
	id: 9,
	name: intl.get("seller")
}];

export const getSPToken = async (currentAccount, tokenId) => {
	// console.log('currentAccount', currentAccount, tokenId);
	try {
		const sptokenFactoryContract = SPTokenFactoryContract();
		return ({
			sptName: await sptokenFactoryContract.getSPTokenName(tokenId), // SPToken name
			sptSymbol: await sptokenFactoryContract.getSPTokenSymbol(tokenId), // SPToken symbol
			sptBalance: await sptokenFactoryContract.getSPTokenTotalSupply(tokenId), // SPToken total supply
			sptAddress: await sptokenFactoryContract.getSPTokenAddress(tokenId), // SPToken contract address
			sptMyBalance: await sptokenFactoryContract.getSPTokenBalanceOfUser(tokenId, currentAccount), // My SPT balance
		})
	} catch(err) {
		console.log(`No SPT for tokenId: ${tokenId}`);
		// console.log("current account: " + currentAccount, tokenId);
		return false;
	}
}

export const getSPTokenAddress = async (tokenId) => await SPTokenFactoryContract().getSPTokenAddress(tokenId);

export const toDataURL = url => fetch(url)
.then(response => response.blob())
.then(blob => new Promise((resolve, reject) => {
	const reader = new FileReader()
	reader.onloadend = () => resolve(reader.result)
	reader.onerror = reject
	reader.readAsDataURL(blob)
}))

export const cidOfIpfsUrl = (ipfsUrl) => ipfsUrl.substr(7, 59);
export const contentOfIpfsUrl = (ipfsUrl) => ipfsUrl.substr(66, ipfsUrl.length);

// Change ipfs://bafybeibxz2cp2pzgukxqxz7b364sdfltpcrfsvxdndnkdufy72mbme5y7q/goldn-116392.mp3 to 
// https://bafybeibxz2cp2pzgukxqxz7b364sdfltpcrfsvxdndnkdufy72mbme5y7q/goldn-116392.mp3.ipfs.w3c.link/goldn-116392.mp3
export const ipfsToHttp = (ipfsUrl) => IPFS_GATEWAY.replace('[cid]', cidOfIpfsUrl(ipfsUrl)).replace('[content]', contentOfIpfsUrl(ipfsUrl));

export const SPTokenFactoryContract = () => new ethers.Contract(SP_TOKEN_FACTORY, sptokenFactory, signer);
export const StakingTokenContract = () => new ethers.Contract(STAKING_TOKEN, erc20, signer);
export const NFTCoreContract = () => new ethers.Contract(NFT_ADDRESS, nft, signer);
export const MarketplaceContract = () => new ethers.Contract(MARKETPLACE_ADDRESS, marketplace, signer);
export const PaymentTokenContract = () => new ethers.Contract(PAYMENT_TOKEN, erc20, signer);
export const SPTokenContract = (address) => new ethers.Contract(address, sptokenAbi, signer);
export const PancakeRoute = () => new ethers.Contract(PANCAKE_ROUTER, pancakeRouter, signer);
export const NusicVault = () => new ethers.Contract(NUSIC_VAULT, nusicVault, signer);
export const AllocationData = () => new ethers.Contract(ALLOCATION_ADDRESS, allocationData, signer);
export const SPTokenVault = () => new ethers.Contract(SPTOKEN_VAULT, sptoken_vault, signer);

export const toWei = (ether) => ethers.utils.parseEther(ether);
export const fromWei = (wei) => ethers.utils.formatEther(wei);

export const formatThousands = require('format-thousands');

export const format = (num, decimal = 0) => {
	return formatThousands(parseFloat(num).toFixed(decimal).toString(), {separator: ','});
}

export const shortAddress = (address, num = 6) => {
	return address.substr(0, num + 2) + "..." + address.substr(address.length - num, num);
}

export const formatAddress = (address) => {
	return address.substr(0, 6) + "..." + address.substr(address.length - 6, 6);
}

export const getNFTStatus = async (nftData, owner, currentAccount) => {
	// onsale - 0, myOnsale - 1, unlisted - 5(not mine), myUnlisted - 3, all - 4
	if(currentAccount === undefined || nftData.tokenId === undefined) return false;
	
	if(owner.toLowerCase() === currentAccount.toLowerCase()) return 3;
	else if(owner.toLowerCase() !== currentAccount.toLowerCase() 
		&& owner.toLowerCase() !== MARKETPLACE_ADDRESS.toLocaleLowerCase()) return 5;
	else if(nftData.sellerAddress !== null 
		&& nftData.sellerAddress.toLowerCase() !== currentAccount.toLowerCase()
		&& owner.toLowerCase() === MARKETPLACE_ADDRESS.toLocaleLowerCase()
		&& nftData.buyerAddress === null) return 0;
	else if(nftData.sellerAddress !== null
		&& nftData.sellerAddress.toLowerCase() === currentAccount.toLowerCase()
		&& owner.toLowerCase() === MARKETPLACE_ADDRESS.toLocaleLowerCase()
		&& nftData.buyerAddress === null) return 1;
	else return false;
}

export const getNFTOwner = async (tokenId) => await NFTCoreContract().ownerOf(tokenId);

export const getUnsupportFrozenTime = async () => await SPTokenFactoryContract().frozenTime();

export const getStakingTokenBalance = async (currentAccount) => await StakingTokenContract().balanceOf(currentAccount);

export const getRate = async () => await SPTokenFactoryContract().rate();

export const getFirstSupportTimestamp = async (tokenId) => {
	try {
		return await SPTokenFactoryContract().getFirstSupportTimestamp(tokenId);
	} catch (err) {
		return ethers.BigNumber.from(MAX_TIMESTAMP);
	}
}

export const getBlockTimestamp = async() => (await provider.getBlock()).timestamp;

export const getNusicPrice = async () => await PancakeRoute().getAmountsOut(
		ethers.BigNumber.from("1000000000000000000"),
		[STAKING_TOKEN, PAYMENT_TOKEN]
	);

export const toBigInt = (n) => n.div(ethers.BigNumber.from('1000000000000000000')).toString();

export const isMintWhitelist = async (currentAccount) => await NFTCoreContract().isMintWhitelist(currentAccount);

// getReleasableByAccount is only for MainNode, TinyNode, Tech, Community, not for IPOwner, IPAgent, IpIncentive and stakers
export const getReleasableByAccount = async (participant, tokenId, currentAccount) => {
	const spTokenFactoryContract = SPTokenFactoryContract();
	const allocationDataContract = AllocationData();
	const has = await allocationDataContract.isShareHolder(participant, currentAccount);
	return await spTokenFactoryContract.getReleasableByAccount(participant, tokenId, currentAccount, has);

	// Following is another way to getReleasableByAccount
	// const isShareHolder = await allocationDataContract.isShareHolder(participant, currentAccount);
	// // console.log("isShareHolder", isShareHolder)
	// if(!isShareHolder) return 0;
	// else {
	// 	const nftAddress = allocationDataContract.getNftAddress(participant);
	// 	const nftContract = new ethers.Contract(nftAddress, nft, signer);
	// 	const totalSupply = await nftContract.totalSupply();
	// 	// console.log("totalSupply", totalSupply);
	// 	if(totalSupply === 0) return 0;
	// 	else {
	// 		const claimed = await spTokenFactoryContract.getSptClaimed(participant, tokenId, currentAccount);
	// 		const releasable = (await getTotalReleasable(participant, tokenId)).div(totalSupply).sub(claimed); //sptClaimed[_participant][tokenId_][addr_]);
	// 		return releasable;
	// 	}
	// }
}

// getReleasableForIP is only for IPOwner, IPAgent and IPIncentive
export const getReleasableForIP = async(participant, tokenId, currentAccount) => {
	// getTotalReleasable(_participant, tokenId_) - sptClaimed[_participant][tokenId_][addr_];
	const spTokenFactoryContract = SPTokenFactoryContract();
	const totalReleasable = await spTokenFactoryContract.getTotalReleasable(participant, tokenId);
	return totalReleasable;
	// Following is another way to getReleasableForIp
	// const totalReleasable = await getTotalReleasable(participant, tokenId);
	// const claimed = await spTokenFactoryContract.getSptClaimed(participant, tokenId, currentAccount);
	// return totalReleasable.sub(claimed);
}

// const getTotalReleasable = async(participant, tokenId) => {
// 	let total = ethers.constants.Zero;
// 	const duration = ethers.BigNumber.from(365 * 24 * 3600);
// 	const spTokenFactoryContract = SPTokenFactoryContract();
// 	const blockTimestamp = ethers.BigNumber.from(Math.floor((new Date()).getTime() / 1000));
// 	const supporters = await spTokenFactoryContract.getSupporters(participant, tokenId);
// 	for(let i = 0; i < supporters.length; i++) {
// 		const timeDiff = blockTimestamp.sub(supporters[i].timestamp);
// 		if(timeDiff >= 0 && timeDiff <= duration) total = total.add((ethers.BigNumber.from(supporters[i].amount)).mul(timeDiff).div(duration));
// 	}
// 	return total;
// }

export const getAllReleasable = async(tokenId, currentAccount) => {
	let sum = ethers.constants.Zero;
	for(let participantId = 1; participantId <= 6; participantId++) {
		if(participantId <= 2) {
			// for IPOwner, IPAgent
			sum = sum.add(await getReleasableForIP(
				participantId,
				tokenId, 
				currentAccount
			));
		} else if(participantId >= 4) {
			// for node and team
			sum = sum.add(await getReleasableByAccount(
				participantId,
				tokenId,
				currentAccount
			));
		}
	}	
	return sum.toString();
}

export const getSPTClaimed = async (participant, tokenId, currentAccount) => await SPTokenFactoryContract().getSptClaimed(participant, tokenId, currentAccount);

export const getClaimableAmount = async(participant, currentAccount) => await NusicVault().getClaimableAmount(participant, currentAccount);

export const getClaimedAmount = async(participant, currentAccount) => await NusicVault().claimed(participant, currentAccount);

export const getTradeTimes = async(tokenId) => await MarketplaceContract()._tradingTimes(tokenId);

export const getIPAccounts = async(tokenId) => await SPTokenFactoryContract().getNFTIPAddresses(tokenId);

export const getShareholders = async(participant) => await AllocationData().shareHolders(participant); // This methods is canceled in contract

export const getGasPrice = async() => await signer.getGasPrice();

export const getAllSPTokens = async() => {
	let result = [];
	const addresses = await SPTokenFactoryContract().getAllSPTokens();
	for(let i = 0; i < addresses.length; i++) {
		const address = addresses[i];
		if(address === ZERO_ADDRESS) continue;
		const spTokenContract = SPTokenContract(address);
		const name = await spTokenContract.name();
		const symbol = await spTokenContract.symbol();
		result.push({
			name,
			symbol,
			address
		})
	}
	return result;
}

export const getTokenBs = async() => {
	let result = [];
	const tokens = await SPTokenVault().getAllowedLiquidityToken();
	for(let i = 0; i < tokens.length; i++) {
		if(tokens[i].token !== ZERO_ADDRESS) {
			const tokenBContract = new ethers.Contract(tokens[i].token, erc20, signer);
			result.push({
				name: await tokenBContract.name(),
				symbol: await tokenBContract.symbol(),
				address: tokens[i].token,
				direction: tokens[i].direction,
			})
		}
	}
	return result;
}

export const getBalance = async(address, currentAccount) => {
	const tokenContract = new ethers.Contract(address, erc20, signer);
	const balance = await tokenContract.balanceOf(currentAccount);
	return balance;
}

export const getPair = async(tokenA, tokenB) => await SPTokenVault().getPair(tokenA, tokenB);

export const getSlippage = async(address) => {
	try {
		const spToken = new ethers.Contract(address, sptokenAbi, signer);
		const allocationRate = await spToken.AllocationRate();
		const lpBonusRate = await spToken.LPBonusRate();
		return({
			allocationRate,
			lpBonusRate
		})
	} catch (err) {
		return({
			allocationRate: 200,
			lpBonusRate: 200,
		})
	}
}

export const getLpAmountInPool = async(address) => {
	if(address === ZERO_ADDRESS) return ethers.BigNumber.from("0");
	const lpToken = new ethers.Contract(address, erc20, signer);
	return await lpToken.balanceOf(SPTOKEN_VAULT);
}

export const getLpAmountOfMine = async(address, currentAccount) => {
	if(address === ZERO_ADDRESS) return ethers.BigNumber.from("0");
	const lpToken = new ethers.Contract(address, erc20, signer);
	return await lpToken.balanceOf(currentAccount);
}

export const getDappLpAmountOfMine = async (address, currentAccount) => {
	if(address === ZERO_ADDRESS) return {amount: 0, timestamp: 0, frozenTime: 0, tokenA: '', amountA: ethers.BigNumber.from('0'), tokenB: '', amountB: ethers.BigNumber.from('0')}
	const data = await SPTokenVault().getLiquidityData(address, currentAccount);
	return(data);
}

export const getPotentialSPTokenBonus = async (tokenA, tokenB, currentAccount) => {
	const data = await SPTokenVault().getPotentialSPTokenBonus(currentAccount, tokenA, tokenB);
	return(data);
}

export const getCurrentPrice = async(lpTokenAddress, amount) => {
	const zero = {priceAtoB: 0, priceBtoA: 0};
	if(amount === 0 || amount === '' || lpTokenAddress === ZERO_ADDRESS) return zero;
	else {
		try {
			const lpToken = new ethers.Contract(lpTokenAddress, pancake_pair, signer);
			const reserves = await lpToken.getReserves();
			const pancakeRouter = PancakeRoute();
			const priceAtoB = await pancakeRouter.getAmountOut(toWei((amount * (1 - PANCAKE_FEE_RATE)).toString()), reserves.reserve0, reserves.reserve1);
			const priceBtoA = await pancakeRouter.getAmountIn(toWei((amount * (1 + PANCAKE_FEE_RATE)).toString()), reserves.reserve0, reserves.reserve1);
			return {
				priceAtoB,
				priceBtoA,
			}
		} catch (err) {
			console.log("ERROR: getCurrentPrice", err.message);
			return zero;
		}
	}
}

export const getLiquidityData = async(lpTokenAddress, amount, direction) => {
	if(amount === 0 || amount === '') return {liquidityAtoB: 0, liquidityBtoA: 0};
	if(lpTokenAddress === ZERO_ADDRESS) return {liquidityAtoB: 0, liquidityBtoA: 0};
	else {
		const lpToken = new ethers.Contract(lpTokenAddress, pancake_pair, signer);
		const reserves = await lpToken.getReserves();
		// console.log(fromWei(reserves.reserve0.toString()), fromWei(reserves.reserve1.toString()));
		return {
			liquidityAtoB: direction ? amount * reserves.reserve1 / reserves.reserve0 : amount * reserves.reserve0 / reserves.reserve1,
			liquidityBtoA: direction ? amount * reserves.reserve0 / reserves.reserve1 : amount * reserves.reserve1 / reserves.reserve0,
		}
	}
}

export const removeLiquidity = async(tokenA, tokenB) => await SPTokenVault().removeLiquidity(tokenA, tokenB);

export const addLiquidity = async(tokenA, tokenB, amountA, amountB, frozenDuration) => await SPTokenVault().addLiquidity(tokenA, tokenB, amountA, amountB, 1, frozenDuration);

export const getAllowance = async(token, currentAccount, spender) => {
	const contract = new ethers.Contract(token, erc20, signer);
	return contract.allowance(currentAccount, spender);
}

export const approve = async(token, spender, amount) => {
	const contract = new ethers.Contract(token, erc20, signer);
	return contract.approve(spender, amount);
}

export const getMyLPtokens = async(currentAccount, spTokens, tokenBs) => {
	let result = [];
	const spTokenVault = SPTokenVault();
	for(let i = 0; i < spTokens.length; i++) {
		const tokenA = spTokens[i].address;
		for(let j = 0; j < tokenBs.length; j++) {
			const tokenB = tokenBs[j].address;
			const lpTokenAddress = await getPair(tokenA, tokenB);
			if(lpTokenAddress !== ZERO_ADDRESS) {
				const liquidityData = await spTokenVault.getLiquidityData(lpTokenAddress, currentAccount);
				if(liquidityData.amount > 0) {
					result.push({
						address: lpTokenAddress,
						symbol: spTokens[i].symbol + "/" + tokenBs[j].symbol,
						balance: liquidityData.amount,
						tokenA: liquidityData.tokenA,
						symbolA: spTokens[i].symbol,
						amountA: liquidityData.amountA,
						tokenB: liquidityData.tokenB,
						symbolB: tokenBs[j].symbol,
						amountB: liquidityData.amountB,
					})
				}
			}
		}
	}
	return result;
} 

export const getEstimateLpTokens = (amountA, amountB) => Math.sqrt(amountA * (1 - SLIPPAGE_RATE) * amountB);